import { render, staticRenderFns } from "./RegisterSmartbox.vue?vue&type=template&id=40f3ec18&scoped=true"
import script from "./RegisterSmartbox.vue?vue&type=script&lang=js"
export * from "./RegisterSmartbox.vue?vue&type=script&lang=js"
import style0 from "./RegisterSmartbox.vue?vue&type=style&index=0&id=40f3ec18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3ec18",
  null
  
)

export default component.exports